import { create } from "zustand";
export type ToastVariants = "default" | "success" | "error" | "outline";
export type ToastPosition =
  | "top-right"
  | "top-left"
  | "top-center"
  | "bottom-right"
  | "bottom-left"
  | "bottom-center";

type ToastOptions = {
  variant?: ToastVariants;
  position?: ToastPosition;
  message: string;
} | null;
interface ToastState {
  toast: ToastOptions;
  setOpenToast: (toast: ToastOptions) => void;
  closeToast: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toast: null,
  setOpenToast: (toast) => set({ toast }),
  closeToast: () => set({ toast: null }),
}));
